import EssentialQuestionsView from "@features/tools/view/essential-questions-view";

const EssentialQuestions = () => {
  return <EssentialQuestionsView />;
};

export default EssentialQuestions;
